import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { IBlockOrderAllocAlert } from '@irb-common/components/banner/banner.model';

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    })
  };
  
  dismissedAlerts: Array<string> = [];
  private sharedReplay$: Observable<Object>;
  private subscriptionTime: number;

  constructor(public _http: HttpClient) {
  }

  getAlerts(): Observable<Object> {
    const currentTime = new Date().getTime();

    if (!this.sharedReplay$ || currentTime - this.subscriptionTime > 3000) {
      this.sharedReplay$ = this._http.get("/irebalone/home-page/get-alerts", this.httpOptions).pipe(
        shareReplay(1,3000)
      );
      
      this.subscriptionTime = currentTime;
    }

    return this.sharedReplay$;
  }

  dismissAlert(type: string): Observable<Object> {    
    return this._http.get("/irebalone/home-page/dismiss-alert/" + type, this.httpOptions);
  }

  getBlockOrderAllocAlerts(): Observable<Object> {
    return this._http.get("/irebalone/blotter/get-allocation-messages", this.httpOptions);
  }

  dismissBlockOrderAllocAlerts(allocationIdsArr: Array<IBlockOrderAllocAlert>): Observable<Object> {
    return this._http.post("/irebalone/blotter/save-allocation-msg-ack", allocationIdsArr, this.httpOptions);
  }
}
